export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licenseGroup/state.js